import { makePublishHelper, makeSubscribeHelper } from '../helpers-creators';

const schema = {};

export const eventFailed = makePublishHelper(
  'eventFailed',
  'wh.common.event.ui.header.deposit.failed',
  schema,
);

export const onEventFailed = makeSubscribeHelper(
  'onEventFailed',
  'wh.common.event.ui.header.deposit.failed',
  schema,
);
